import React from "react";
import { Router } from "@reach/router";
import { ApolloConsumer } from "react-apollo";
import { GlobalLayout } from "../components/Layout";
import * as route from "./routes";
import DashboardWrapper from "../components/Layout/DashboardWrapper";
import Landing from "../pages/Landing/Landing";
import CreateAccount from "../pages/CreateAcount/CreateAccount";
// import NotFound from "../pages/NotFound";
import Register from "../pages/Register/Register";
import AffiliatesByAgency from "../pages/Affiliation/AffiliatesAgency/AffiliatesByAgency";
import CheckCode from "../pages/CreateAcount/CheckCode";
import AffiliateDocumentsSection from "../pages/DocumentUpload/AffiliateDocumentsSection";
import QRRedirectPage from "../pages/QRRedirectPage";

const RouterApp = () => (
  <GlobalLayout>
    <ApolloConsumer>
      {client => (
        <Router>
          <Landing path="/" />
          <CheckCode path="check-code/:code" />
          <QRRedirectPage path="qr/:affiliateID" />
          <AffiliateDocumentsSection path={`${route.documentUpload}/:code`} />
          <CreateAccount path={route.createAccount} />
          <DashboardWrapper path={route.dashboard} client={client}>
            <Register path={`${route.register}/:userId`} />
            <AffiliatesByAgency
              path={`${route.affiliatesAgency}/detail/:agencyID`}
            />
          </DashboardWrapper>
        </Router>
      )}
    </ApolloConsumer>
  </GlobalLayout>
);

export default RouterApp;
